/** 案件 条件相談メッセージ：ステータス 下書き */
export const RFP_NEGOTIATE_MESSAGE_STATUS_DRAFT = {
    label: '下書き保存',
    message: '下書き保存',
    value: 1,
};
/** 案件 条件相談メッセージ：ステータス 送信済 */
export const RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC = {
    label: '返信',
    message: 'メッセージを送信',
    value: 2,
};
/** 案件 条件相談メッセージ：ステータスの一覧 */
export const RFP_NEGOTIATE_MESSAGE_STATUSES = [
    RFP_NEGOTIATE_MESSAGE_STATUS_DRAFT,
    RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC,
];
